import React from "react";
import IconsLandingPage from "../components/IconsLandingPage";
import Footer from "../components/Footer";

const Icons = props => {
  return (
    <React.Fragment>
      <IconsLandingPage text="edition: icons" title="the b-side"></IconsLandingPage>
    </React.Fragment>
  );
};

export default Icons;
